import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./schedulingLoopNew.scss";
import { useSelector } from "react-redux";
import { 
    Schedules_list,
    Schedules_Datalist_Loop, 
    ScheduleLoop_update,
    programValidate,
    adValidate,
} from "../../../api/api";
import icroundsearch from "../../../assets/images/ic_round-search.svg";
import { toast, ToastContainer } from "react-toastify";
import deleteIcon from '../../../assets/images/delete_forever.png';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import editIcon from '../../../assets/images/edit-outline.svg';
import ellipse from "../../../assets/images/Ellipse.png";
import { 
    fetchSchedule,
    update_schedule
} from "./utils/fetchAndUpdateLoopApi";
import { handleDrop, handelProgramDoubleClick } from "./utils/handleDropLoop";
import { 
    channelDragStart,
    handleDragStart,
    handleDragOver,
    handleDragOver2,
} from "./utils/handleDragloop";
import { handleProgramDelete, deleteEvent } from "./utils/handleDeleteLoop";
import { 
    addAdsOnClick,
    millisecondsToHuman,
    verifyMilliSeconds,
    totalScheduleTimeFun,
    generateTimeSlots,
    calculateMinutes,
    getAssetInfo,
    setAdsTime,
    selectedFiller,
    searchProgram,
    handleSorting
} from "./utils/utils";
import { Left } from "../scheduling-linear-new/components/left/left";
import { SearchBar } from "../scheduling-linear-new/components/left/child-component/SearchBar";
import { ChannelListing } from "../scheduling-linear-new/components/left/child-component/ChannelListing";
import { AdsButton } from "../scheduling-linear-new/components/left/child-component/AdsButton";
import { Right } from "../scheduling-linear-new/components/right/Right";
import { HeaderSection } from "./components/HeaderSection";
import { MiddleContent } from "./components/MiddleContent";
import { RightSideContent } from "./components/RightSideContent";
import { ZoomControls } from "./components/ZoomControls";
import { ScheduleDetails } from "./components/ScheduleDetails";
import { TableBody } from "./components/TableBody"; 
import { TimeSlots } from "./components/TimeSlots";
import { AdBreaksContainer } from "./components/AdBreaksContainer";
import { DraggableTableRow } from "./components/DraggableTableRow";
import AssetInfoCard from "./components/AssetInfoCard";
import AdBreaksTable from "./components/AdBreaksTable";
import { NavigationButtons } from "./components/NavigationButtons";
import { Height } from "@material-ui/icons";
import useUndo from "use-undo";

function SchedulingLoopNew() {
    const locationState = useLocation();
    const [programList, setProgramList] = useState();
    const [originalProgramList, setOriginalProgramList] = useState([]);
    const [promoList, setPromoList] = useState();
    const [fillerList, setFillerist] = useState();
    // const [gridList, setGridList] = useState();
    const [
        gridListState,
        {
            set: setGridList,
            reset: resetGridList,
            undo: undoGridList,
            redo: redoGridList,
            canUndo,
            canRedo,
        },
    ] = useUndo([]);
    const { present: gridList } = gridListState;
    const [shouldSort, setShouldSort] = useState(null);
    const [loaderStatus, setLoaderStatus] = useState(false);
    const [draggableType, setDraggableType] = useState(null);
    const [totalDuration, setTotalDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [totalVideoDuration, setTotalVideoDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [totalAdDuration, setTotalAdDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [totalPromosDuration, setTotalPromosDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [selectedTab, setSelectedTab] = useState("Programs");
    const [zoomInOut, setZoomInOut] = useState(10);
    const [assetInfo, setAssetInfo] = useState(null);
    const [categoryTab, setCategoryTab] = useState("Ads");
    const [seqId, setSeqId] = useState(1);
    const [hoveredId, setHoveredId] = useState(null);    
    const [linePosition, setLinePosition] = useState(null);
    const [hoverTime, setHoverTime] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const [singleTimeSlots, setSingleTimeSlots] = useState([]);
    const [searchedText, setSearchedText] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const draggedItem = useRef();    
    const {
        appThemeReducer: { appTheme },
    } = useSelector((state) => state);    
    const navigate = useNavigate();

    const totalScheduleTimeFunc = () => {
        totalScheduleTimeFun(
            gridList,
            singleTimeSlots,
            setTimeSlots,
            setTotalDuration,
            setTotalVideoDuration,
            setTotalAdDuration,
            setTotalPromosDuration
        )
    }

    const adAdsOnClick = (sequenceId, adType) => {
        addAdsOnClick(
            sequenceId,
            locationState,
            adValidate,
            gridList,
            verifyMilliSeconds,
            millisecondsToHuman,
            setGridList,
            toast,
            setIsEdit,
            adType,
            promoList,
            assetInfo,
            funcSorting,
        )
    }
    
    const deleteAdEvent = (seqId, sequenceId) => {
        deleteEvent(
            seqId, 
            sequenceId,
            gridList,
            setGridList,
            millisecondsToHuman,
            setIsEdit
        )
    }

    const programDelete = (index) => {
        handleProgramDelete(
            index,
            gridList,
            setGridList,
            millisecondsToHuman,
            setIsEdit
        )
    }

    const handleDragStarts = (event) => {
        handleDragStart(
            event,
            draggedItem
        )
    }

    const handleDragOvers = (event) => {
        handleDragOver(
            event,
            draggedItem,
            setDraggableType
        )
    }

    const handleDragOvers2 = (event, id) => {
        handleDragOver2(
            event,
            id,
            setHoveredId,
            zoomInOut,
            setLinePosition,
            setHoverTime
        )
    }
    
    const handelProgramOnClick = (data, index) => {
        handelProgramDoubleClick (
            data, 
            index,
            gridList,
            setGridList,
            locationState,
            programValidate,
            toast,
            setIsEdit
        )
    }
    
    const handleAdsAndProgramDrop = (event) => {
        handleDrop(
            event,
            setHoveredId,
            setLinePosition,
            draggedItem,
            setSeqId,
            gridList,
            setHoverTime,
            adValidate,
            verifyMilliSeconds,
            hoverTime,
            millisecondsToHuman,
            toast,
            setCategoryTab,
            setGridList,
            programValidate,
            locationState,
            setIsEdit
        )
    }

    const fetchLoopData = () => {
        fetchSchedule(
            setLoaderStatus,
            locationState,
            Schedules_list,
            setProgramList,
            setOriginalProgramList,
            setFillerist,
            setPromoList,
            Schedules_Datalist_Loop,
            millisecondsToHuman,
            setAssetInfo,
            setGridList
        )
    }

    const updateLoopData = () => {
        update_schedule(
            setLoaderStatus,
            ScheduleLoop_update,
            gridList,
            locationState,
            toast,
            fetchLoopData,
            setIsEdit,
            assetInfo,
            funcSorting,
        )
    }
    // const updateLoopData = async () => {
    //     setLoaderStatus(true);
    //     let updatedGridList = funcSorting(assetInfo?.sequence)
    //     if (updatedGridList) {
    //         const response = await ScheduleLoop_update(updatedGridList, locationState?.state?.channelId);
    //         if (response) {
    //             toast.success("Channel Updated successfully", {
    //             position: toast.POSITION.BOTTOM_RIGHT,
    //             autoClose: 3000
    //             });
    //             fetchLoopData();
    //             // setLoaderStatus(false);
    //             setIsEdit(false);
    //         } else {
    //             toast.error("Channel Update failed", {
    //             position: toast.POSITION.BOTTOM_RIGHT,
    //             autoClose: 3000
    //             });
    //             setIsEdit(false);
    //             setLoaderStatus(false);
    //         }
    //     }
    // }

    const toGetAssetInfo = (sequenceId) => {
        getAssetInfo(
            sequenceId,
            gridList,
            setAssetInfo,
            setSeqId
        )
    }

    const updateAdsTime = (e, adSqId, sequenceId) => {
        setAdsTime(
            e, 
            adSqId, 
            sequenceId,
            gridList,
            toast,
            setGridList,
            setIsEdit
        )
    }

    const funcSorting = (sequenceId) => {
        return handleSorting (
            sequenceId,
            gridList,
            toast,
            setGridList,
            setIsEdit,
        )
    }

    useEffect(() => {
        if (shouldSort !== null) {   
            funcSorting(shouldSort);
            setShouldSort(null); // Reset it
        }
    }, [gridList, shouldSort]); // ✅ will wait for latest gridList

    const selectedFillers = (id, adSqId, sequenceId, adType) => {
        selectedFiller(
            id, 
            adSqId, 
            sequenceId,
            fillerList,
            gridList,
            setGridList,
            adType,
            promoList,
        )
    }

    const searchPrograms = (text) => {
        searchProgram(
            text,
            originalProgramList,
            setProgramList,
            setSearchedText
        )
    }

    const programZoomLevel = () => {
        const categoryPriority = {
            "Music": 20,
            "Entertainment": 5,
            "Kids": 15,
            "News & Opinion": 5,
            "Health & Fitness": 5,
            "Devotional": 3,
            "Short Films": 4,
            "Web Series": 5,
        };
        const categories = locationState?.state?.categories || [];

        if (!categories.length) return;
        const sorted = categories.sort((a, b) => {
            return (categoryPriority[b] || 0) - (categoryPriority[a] || 0);
        });
        const topCategory = sorted[0];
        setZoomInOut(categoryPriority[topCategory] || 1);
    }

    useEffect(() => {
        totalScheduleTimeFunc();
        toGetAssetInfo(seqId);
    },[gridList, seqId])
    
    useEffect(()=> {
        fetchLoopData();
        programZoomLevel();
    },[locationState])

    // Set the time slots in state when the component mounts
    useEffect(() => {
        const slots = generateTimeSlots();
        setTimeSlots(slots);
        setSingleTimeSlots(slots);
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.ctrlKey && e.key === 'z') {
            e.preventDefault();
            if (canUndo) undoGridList();
          }
      
          if ((e.ctrlKey && e.key === 'y') || (e.ctrlKey && e.shiftKey && e.key === 'z')) {
            e.preventDefault();
            if (canRedo) redoGridList();
          }
        };
      
        window.addEventListener('keydown', handleKeyDown);
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, [canUndo, canRedo, undoGridList, redoGridList]);

    const handleZoomIn = () => {
        setZoomInOut((prevZoom) => Math.min(prevZoom + 1, 25));
    };
    
    const handleZoomOut = () => {
        setZoomInOut((prevZoom) => Math.max(prevZoom - 1, 1));
    };

    const handlecategoryTab = (tab) => {
        setCategoryTab(tab);
    };

    const setWeeklyView = () => {
        if (isEdit) {
            toast.error("You have unsaved changes. Please save them before leaving this page.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
        } else {
            const redirectPage =  "/scheduling-linear";
            const data = locationState?.state;
            navigate(redirectPage, {
                state: {
                    channelId: data?.channelId,
                    channelName: data?.channelName,
                    type: data?.type,
                    defaultFiller: data?.defaultFiller,
                    permission: data?.permission,
                    channelAssembly: data?.channelAssembly,
                    gridList: gridList,
                    weeklyView: true
                }
            });
        }
    };

    return (
        <div className={`content-body SchedulingDetail SchedulingLoop scheduling-loop-content-body ${appTheme}`}>
            <div className="dashboard-content flex schedule-loop-view">
                <Left>
                    <SearchBar appTheme={appTheme} searchedText={searchedText} searchPrograms={searchPrograms} />
                    <ChannelListing programList={programList} promoList={promoList} fillerList={fillerList} locationState={locationState} channelDragStart={channelDragStart} handelProgramOnClick={handelProgramOnClick} draggedItem={draggedItem} />
                    <AdsButton locationState={locationState} draggedItem={draggedItem} channelDragStart={channelDragStart} />
                </Left>
                        
                <Right customStyle={{width: "100%", height: "100%"}}>
                    <div className="top-content">
                        <HeaderSection locationState={locationState} updateLoopData={updateLoopData} loaderStatus={loaderStatus} undoGridList={undoGridList} redoGridList={redoGridList} canUndo={canUndo} canRedo={canRedo} setWeeklyView={setWeeklyView} fetchLoopData={fetchLoopData} />
                    </div>
                    <div className="bottom-content row mt-2 px-2">
                        <MiddleContent>
                            <div className="middle-up row">
                                <ZoomControls handleZoomIn={handleZoomIn} handleZoomOut={handleZoomOut} />
                                <ScheduleDetails appTheme={appTheme} totalDuration={totalDuration} totalVideoDuration={totalVideoDuration} totalAdDuration={totalAdDuration} totalPromosDuration={totalPromosDuration} />
                            </div>
                            <div className="middle-down">
                                <TableBody handleDragStarts={handleDragStarts} handleDragOvers={handleDragOvers} handleAdsAndProgramDrop={handleAdsAndProgramDrop}>
                                    {/* Render timeSlots in a separate loop */}
                                    <TimeSlots timeSlots={timeSlots} zoomInOut={zoomInOut} />
                                    {/* Render gridList as you already have it */}
                                    <div className="grid-list-container col-10 p-2">
                                    { gridList?.length !== 0?
                                        gridList?.map((data, index) => {
                                            return (
                                                <section 
                                                    className="d-flex px-2" 
                                                    id={`sequenceId${data?.sequence}`}
                                                    onDragOver={(e) => handleDragOvers2(e, data.sequence)}
                                                >
                                                    <AdBreaksContainer calculateMinutes={calculateMinutes} data={data} zoomInOut={zoomInOut} linePosition={linePosition} hoveredId={hoveredId} draggableType={draggableType} hoverTime={hoverTime} />
                                                    <DraggableTableRow toGetAssetInfo={toGetAssetInfo} data={data} locationState={locationState} index={index} calculateMinutes={calculateMinutes} zoomInOut={zoomInOut} assetInfo={assetInfo} millisecondsToHuman={millisecondsToHuman} programDelete={programDelete} deleteIcon={deleteIcon} />
                                                </section>
                                            )
                                        })
                                        :
                                        <td colspan="5" class="text-center no-data">
                                            No data has been scheduled.
                                        </td>
                                    }
                                    </div>
                                </TableBody>
                            </div>
                        </MiddleContent>
                        <RightSideContent>
                            <AssetInfoCard assetInfo={assetInfo} millisecondsToHuman={millisecondsToHuman} appTheme={appTheme} categoryTab={categoryTab} />
                            <AdBreaksTable appTheme={appTheme} categoryTab={categoryTab} handlecategoryTab={handlecategoryTab} locationState={locationState} assetInfo={assetInfo} selectedFillers={selectedFillers} fillerList={fillerList} millisecondsToHuman={millisecondsToHuman} updateAdsTime={updateAdsTime} deleteAdEvent={deleteAdEvent} deleteIcon={deleteIcon} adAdsOnClick={adAdsOnClick} promoList={promoList} setShouldSort={setShouldSort} />
                            <NavigationButtons appTheme={appTheme} programDelete={programDelete} assetInfo={assetInfo} toGetAssetInfo={toGetAssetInfo} gridList={gridList} setShouldSort={setShouldSort} />
                        </RightSideContent>
                    </div>
                </Right>
            </div>
            <ToastContainer />
            {
                loaderStatus &&
                <div className="loader-container">
                    <div className="loader"></div>
                    <p></p>
                </div>
            }
        </div>
    )
}

export default SchedulingLoopNew;